// extracted by mini-css-extract-plugin
export var container = "buyers-guide-module--container--PtbrF";
export var tiers = "buyers-guide-module--tiers--HCx7a";
export var sidePanel = "buyers-guide-module--sidePanel--8NUM1";